import { render, staticRenderFns } from "./DetalheContratoAcoes.vue?vue&type=template&id=2b0820ce"
import script from "./DetalheContratoAcoes.vue?vue&type=script&lang=js"
export * from "./DetalheContratoAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports